/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AtsPushResult {
  ok: boolean;
  landed_rung?: string | null;
  remote_id?: string | null;
  error_code?: string | null;
  error_message?: string | null;
}
